import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "../../common";

const NAVIGATION_SHOW = "navigation/show";
const NAVIGATION_SHOW_DICTIONARY = "navigationDictionary/show";
export const showNavigation = createAsyncThunk(
  NAVIGATION_SHOW,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.get(`Navigation/list(${payload})`, {
        headers: {
          MappedState: 1,
        },
      });
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showNavigationDictionary = createAsyncThunk(
  NAVIGATION_SHOW_DICTIONARY,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.get("Navigation", {
        params: {
          // /?$orderby=text&$expand=items
          $orderby: "text",
          $expand: "items",
        },
        data: payload,
      });
      return {
        id: data.value.Oid,
        key: data.value.text,
        items: data.value.items,
      };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
